<div class="menu">
  <div #scrollingWrapper class="border-bottom scrolling-wrapper">
    <ng-content></ng-content>
  </div>
</div>
<div *ngIf="!!supportText">
  <p class="support-text">{{ supportText | translate }}</p>
</div>
